// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__q6sUL","title":"Images45_title__2Xz2z","images":"Images45_images__3KgLI"};